/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NextGenReportScheduleRequest extends models.NextGenReportScheduleRequestBase {
    constructor() {
        super();
        this.setDiscriminator("NextGenReportScheduleRequest");
    }

    getFixupPrototypeFunction() { return NextGenReportScheduleRequest.fixupPrototype; }

    static newInstance(model: Partial<NextGenReportScheduleRequest>): NextGenReportScheduleRequest {
        let obj = Object.assign(new NextGenReportScheduleRequest(), model);
        NextGenReportScheduleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NextGenReportScheduleRequest>): NextGenReportScheduleRequest {
        if (!model) return null;
        return NextGenReportScheduleRequest.newInstance(<NextGenReportScheduleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NextGenReportScheduleRequest) {
        if (!obj) return;

        models.NextGenReportScheduleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NextGenReportScheduleRequest): boolean {
        if (models.NextGenReportScheduleRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, NextGenReportScheduleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * User ID of user who scheduled the report
     */
    created_by: string;

    /**
     * Schedule ID of which the report to be generated
     */
    schedule_id: string;

    /**
     * List of Email IDs for which the scheduled report will be sent.
     */
    email_recipients: Array<string>;

    /**
     * NextGen Report type
     */
    report_type: models.NextGenReportType;

    /**
     * Run ID of which the report to be re-triggered.
     */
    report_run_id: string;

    filters: models.QueryOperator;

}
